import type { BadgeRule } from "~/lib/badges/types";

const GID_COLLECTION_PREFIX = "gid://shopify/Collection/";

export const collectionsRule: BadgeRule = {
  name: "collections",
  evaluate: (product, badge) => {
    if (!badge.criteriaCollections.length) return true;

    return product.collections.some((col) => {
      const numericId = col.id.replace(GID_COLLECTION_PREFIX, "");
      return badge.criteriaCollections.some(
        (required) => col.handle.toLowerCase() === required.toLowerCase() || numericId === required,
      );
    });
  },
};
